<template>
    <section class="help">
        <h3 class="help__title">{{ $t('discussions.title') }}</h3>
        <TheButton class="help__button" :title="$t('discussions.button')" @click="openQuestionSubmissionModal" />
    </section>
</template>

<script lang="ts">
import TheButton from '~/components/ui/TheButton.vue'
import { useBasketStore } from '~/stores/basket'

export default {
    components: {
        TheButton,
    },
    methods: {
        openQuestionSubmissionModal() {
            const basketStore = useBasketStore()
            const authUser = basketStore.authUser
            if (authUser !== null) {
                useNuxtApp().$bus.$emit('showModal', 'question-submission-form')
            } else {
                useNuxtApp().$bus.$emit('openModalForLogin')
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.help {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1.5rem 0;
    margin: 0;

    &__title {
        font-size: 18px;
        margin: 0;
    }

    &__button {
        margin-top: 1.3rem;
    }
}
</style>
